import { Component, Inject, Injector, OnInit, Optional, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { REQUEST } from '@nguniversal/express-engine/tokens';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { FieldSetting } from 'src/app/share/entity/FieldSetting';
import { BreadCrumbService } from 'src/app/share/service/bread-crumb.service';
import { CommonHttpClientService } from 'src/app/share/service/common-http-client.service';
import { OptionService } from 'src/app/share/service/option.service';
import { ServerConfigService } from 'src/app/share/service/server-config.service';
import { CmsService } from 'src/app/web-generator/cms-generator/service/cms.service';
import { GENERATOR_ENV_TOKEN, GeneratorEnv } from 'src/app/web-generator/generator-env-token';
import { TemplateService } from 'src/app/web-generator/template-generator/service/template.service';
import { AbstractCmsNormal } from '../../abstract-cms-normal';
import * as moment from 'moment';

@Component({
  selector: 'app-normal-01',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent extends AbstractCmsNormal {
  searchSource: string;
  limit$ = new BehaviorSubject<number>(9);
  sort$ = new BehaviorSubject<string>('');

  menuSetting: { [p: string]: FieldSetting } = {
    search: { title: 'search', isDefault: true, openStatus: true },
    category: { title: 'category', isDefault: true, searchStatus: true },
  };

  searchData = {
    start: null,
    end: null,
  }

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected cmsService: CmsService,
    protected translate: TranslateService,
    protected optionService: OptionService,
    protected http: CommonHttpClientService,
    @Inject(GENERATOR_ENV_TOKEN) protected generatorEnv: GeneratorEnv,
    @Inject(PLATFORM_ID) protected platformId: object,
    protected injector: Injector,
    protected templateService: TemplateService,
    protected serverConfigService: ServerConfigService,
    @Optional() @Inject(REQUEST) protected request: Request,
    protected breadCrumbService: BreadCrumbService,
  ) {
    super(route, router, cmsService, translate, optionService, http, generatorEnv, platformId, injector, templateService, serverConfigService, request, breadCrumbService);
  }

  toggleOrder(o: 'desc' | 'asc') {
    if (o === this.order$.getValue()) {
      return;
    }
    this.order$.next(o);
    this.sort$.next('open_start_date');
  }

  toDetailPage(id: any) {
    this.router.navigate([id], {relativeTo: this.route, queryParamsHandling: 'merge'});
  }

  genMoment(v) {
    if (v) {
      return moment(v, 'YYYY/MM/DD', false);
    }
  }


  querySearchStartDate(event: string) {
    const start = moment(event).format('YYYY-MM-DD');
    this.querySearch({start: start})
  }

  querySearchEndDate(event: string) {
    const end = moment(event).format('YYYY-MM-DD');
    this.querySearch({end: end})
  }


}
